import type React from 'react';
import { Box } from '@mui/material';
import { useFetchNotifications } from '../hooks/useFetchNotifications';
import { useRef } from 'react';
import NotificationList from './NotificationList';
import { NotificationApiFilters } from '../hooks/useNotificationsFilter';

const notificationlistStyles = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 2,
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  width: 'calc(100% - 26px)',
  height: 'calc(100% - 26px)',
  minWidth: { xs: 'calc(100% - 26px)', md: '500px' },
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

interface NotificationWrapperProps {
  filters: NotificationApiFilters;
}

export const NotificationWrapper: React.FC<NotificationWrapperProps> = ({ filters }) => {
  const contentBoxRef = useRef<HTMLDivElement>(null);

  const {
    notifications,
    error,
    isError,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    markNotification
  } = useFetchNotifications(filters);

  return (
    <Box ref={contentBoxRef} sx={notificationlistStyles}>
      <NotificationList
        key={JSON.stringify(filters)}
        notifications={notifications}
        isLoading={isLoading}
        isError={isError}
        error={error as Error}
        isFetchingNextPage={isFetchingNextPage}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        rootRef={contentBoxRef}
        handleNotificationStatus={markNotification}
      />
    </Box>
  );
};

export default NotificationWrapper;